<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(faturamento.nome) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Guias</strong></td>
            <td>
              <button
                data-test-id="button-exibiralertavalores-1"
                type="button"
                style="padding: 0; margin: 0"
                class="btn btn-xs btn-link"
                @click="
                  exibirAlertaValores(
                    'Guias',
                    faturamento.guias,
                    [
                      'autorizacao.numeroGuia',
                      'beneficiario.nome',
                      'beneficiario.plano',
                      'autorizacao.dataEmissao',
                      'agendamentos.length',
                    ],
                    [
                      'Número',
                      'Paciente',
                      'Plano',
                      'Data Emissão',
                      'Quantidade Agendamentos',
                    ]
                  )
                "
              >
                Ver todas
              </button>
            </td>
          </tr>
          <tr>
            <td><strong>Finalizado</strong></td>
            <td
              :class="faturamento.finalizado ? 'text-success' : 'text-danger'"
            >
              {{ faturamento.finalizado ? '' : 'Não' }}
              <span v-if="faturamento.finalizado" class="text-info">
                {{ formatarData(faturamento.finalizado, 'DD/MM/YYYY') }}
              </span>
            </td>
          </tr>
          <tr>
            <td><strong>Arquivado</strong></td>
            <td :class="faturamento.arquivado ? 'text-success' : 'text-danger'">
              {{ faturamento.arquivado ? '' : 'Não' }}
              <span v-if="faturamento.arquivado" class="text-info">
                {{ formatarData(faturamento.arquivado, 'DD/MM/YYYY') }}
              </span>
            </td>
          </tr>
          <tr>
            <td><strong>Glosa</strong></td>
            <td :class="faturamento.glosa ? 'text-success' : 'text-danger'">
              {{ faturamento.glosa ? '' : 'Não' }}
              <span v-if="faturamento.glosa" class="text-info">
                {{ formatarData(faturamento.glosa, 'DD/MM/YYYY') }}
              </span>
            </td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="faturamento.ativo ? 'text-success' : 'text-danger'">{{
              faturamento.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          id="botaoEditar"
          data-test-id="link-botaoeditar"
          :to="'/faturamento/cadastro/' + faturamento._id"
          name="botaoEditar"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
        <a
          v-if="exibeFinalizar"
          id="botaoFinalizar"
          data-test-id="a-botaofinalizar"
          href="#"
          name="botaoFinalizar"
          class="btn btn-sm btn-default"
          @click.prevent="finalizar(faturamento)"
        >
          <span class="fa fa-calendar" /> Finalizar
        </a>
        <a
          v-if="exibeArquivar"
          id="botaoArquivar"
          data-test-id="a-botaoarquivar"
          href="#"
          name="botaoArquivar"
          class="btn btn-sm btn-default"
          @click.prevent="arquivar(faturamento)"
        >
          <span class="fa fa-folder" /> Arquivar
        </a>
        <a
          v-if="exibeGlosa"
          id="botaoGlosa"
          data-test-id="a-botaoglosa"
          href="#"
          name="botaoGlosa"
          class="btn btn-sm btn-default"
          @click.prevent="glosa(faturamento)"
        >
          <span class="fa fa-exclamation-circle" /> Glosa
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'FaturamentoFicha',
  mixins: [alertaMixin],
  props: {
    faturamento: {
      type: Object,
      required: true,
    },
  },
  computed: {
    exibeFinalizar() {
      return this.faturamento.finalizado === null
    },
    exibeArquivar() {
      if (
        this.faturamento.finalizado !== null &&
        this.faturamento.arquivado === null
      ) {
        if (this.faturamento.glosa !== null) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    exibeGlosa() {
      if (
        this.faturamento.finalizado !== null &&
        this.faturamento.glosa === null
      ) {
        if (this.faturamento.arquivado !== null) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
  },
  methods: {
    ...formatadores,
    finalizar(faturamento) {
      this.$emit('finalizar', faturamento)
    },
    arquivar(faturamento) {
      this.$emit('arquivar', faturamento)
    },
    glosa(faturamento) {
      this.$emit('glosa', faturamento)
    },
  },
}
</script>
